import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { VelocityComponent } from 'velocity-react'
import apiservice from '../services/apiservices'
import '../static/css/forgotpassword.css'
import '../../../static/css/font-awesome.css'

class ForgotPasswordRequest extends Component {
    constructor() {
        super()
        this.state = {
            loadervisibility: 'none',
            errorVisibility: 'none',
            errorMessage: '',
            isEmailSubmitted: false,
            ip: '',
            details: '',
        }
        this.componentStillMounted = true
        this.emailInputComponent = null
    }

    componentWillMount() {
        // this.getIP()
        this.getBrowserInfo()
    }

    // getIP = () => {
    //     fetch("http://jsonip.com/?callback")
    //         .then(res => res.json())
    //         .then(res => {
    //             if(this.componentStillMounted) {
    //                 this.setState({ ip: res.ip })
    //             }
    //         })
    //         .catch(err => {
    //             console.log(err)
    //         })
    // }

    getBrowserInfo = () => {
        return navigator.sayswho = (function () {
            let ua = navigator.userAgent, tem,
                M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || []
                return 'IE ' + (tem[1] || '')
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
                if (tem != null) {
                    return tem.slice(1).join(' ').replace('OPR', 'Opera')
                }
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
            // M = M[2] ? [M[1]] : [navigator.appName, '-?']
            tem = ua.match(/version\/(\d+)/i)
            if (tem) {
                M.splice(1, 1, tem[1])
            }

            if (this.componentStillMounted) {
                this.setState({ details: M.join(' ') })
            }
        }).bind(this)()
    }

    componentWillUnmount() {
        this.componentStillMounted = false
    }

    forgotPasswordRequestCall = () => {
        if (this.emailInputComponent.value.trim() !== "") {
            this.verifyEmailId()
        } else {
            this.setState({
                loadervisibility: 'none',
                errorVisibility: 'block',
                errorMessage: 'Please enter your email'
            })
            this.emailInputComponent.focus()
            this.refs.velocity.runAnimation()
        }
    }

    verifyEmailId = () => {
        this.setState({ loadervisibility: 'block', errorVisibility: 'block', errorMessage: 'Verifying, Please wait' })
        let browserInfo = this.state.details
        let ip = this.state.ip
        let data = {}, sourceDetails = {}
        data.registered_email = this.emailInputComponent.value.trim()
        sourceDetails.ip = ip ? ip : "NA"
        sourceDetails.details = browserInfo ? browserInfo : "NA"
        data.source_details = sourceDetails
        apiservice.verifyEmailId(data)
            .then(responseData => {
                if (responseData.status === "SUCCESS") {
                    this.setState({
                        loadervisibility: 'none',
                        errorVisibility: 'none',
                        errorMessage: '',
                        isEmailSubmitted: true,
                    })
                } else {
                    this.setState({
                        loadervisibility: 'none',
                        errorVisibility: "block",
                        errorMessage: responseData.message,
                    })
                    this.refs.velocity.runAnimation()
                }
            })
            .catch(err => {
                this.setState({
                    loadervisibility: 'none',
                    errorVisibility: 'block',
                    errorMessage: 'Something went wrong.'
                })
                console.error("Error message: ", err)
                this.refs.velocity.runAnimation()
            })
    }

    successfullCall = () => {
        this.props.history.push("/")
    }

    resetErrorMessage = () => {
        this.setState({ loadervisibility: 'none', errorVisibility: 'none', errorMessage: '' })
    }

    render() {
        let HBB_logo = require('../../../static/img/bbms-logo.png')
        let effect = "tada"
        let animation = 'callout.' + effect

        if (!this.state.isEmailSubmitted) {
            return (
                <div className="forgot-password-page">
                <div className="login-box forgot-password-request">
                    <div className="login-logo">
                        <img style={{ height: '60px', alignContent: 'center' }} alt="GMS logo"
                            src={HBB_logo} />
                    </div>
                    <div className="login-box-body">
                        <p className="login-box-msg" style={{ fontWeight: 600 }}>
                            Enter your registered Email Id to Reset your Password
                        </p>

                        <form style={{ marginTop: "20px" }}>
                            <VelocityComponent ref="velocity" key={effect} animation={animation} runOnMount={false}>
                                <div className="form-group has-feedback">
                                    <input type="email" className="form-control" placeholder="Email"
                                        ref={(el) => this.emailInputComponent = el}
                                        onChange={(e) => {
                                            e.preventDefault()
                                            this.resetErrorMessage()
                                        }}
                                        onKeyPress={(e) => {
                                            var code = (e.keyCode ? e.keyCode : e.which);
                                            if (code === 13) { //Enter keycode                        
                                                e.preventDefault()
                                                this.forgotPasswordRequestCall()
                                            }
                                        }} />
                                    <span className="fa fa-envelope form-control-feedback"></span>
                                </div>
                            </VelocityComponent>

                            <div className="row" style={{ marginTop: "40px" }}>
                                <div className="col-xs-12">
                                    <button className="btn btn-primary btn-block btn-flat submit-button"
                                        onClick={(e) => {
                                            e.preventDefault()
                                            this.forgotPasswordRequestCall()
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                            <div
                                className="form-group has-error login-error-text"
                                style={{
                                    marginTop: "20px",
                                    marginRight: "10px",
                                    marginLeft: "5px",
                                    display: this.state.loadervisibility,
                                }}>
                                <label className="control-label loader" style={{ fontSize: "15px" }} />
                            </div>
                            <div
                                className="form-group has-error reset-error-text"
                                style={{
                                    marginTop: "20px",
                                    marginRight: "10px",
                                    marginLeft: "5px",
                                    display: this.state.errorVisibility,
                                }}>
                                <label className="control-label" style={{ fontSize: "15px" }} >
                                    {this.state.errorMessage}
                                </label>
                            </div>
                        </form>
                    </div>
                </div>
                </div>
            )
        } else {
            return (
            <div className="forgot-password-page">
                <div className="login-box forgot-password-request">
                    <div className="login-logo">
                        <img style={{ height: '60px', alignContent: 'center' }} alt="GMS logo"
                            src={HBB_logo} />
                    </div>
                    <div className="login-box-body">
                        <div className="row">
                            <div className="col-md-2 col-sm-2 col-xs-2" style={{ textAlign: "center" }}>
                                {/* <a className="btn btn-app"> */}
                                <i className="fa fa-check fa-4x" />
                                {/* </a> */}
                            </div>
                            <div className="col-md-10 col-sm-10 col-xs-10">
                                <p className="login-box-msg" style={{ fontWeight: 600 }}>
                                    Your request is successfully sent. Please check your email for a link to reset your password.
                                </p>
                            </div>
                        </div>

                        <div className="row" style={{ marginTop: "40px" }}>
                            <div className="col-xs-12">
                                <button className="btn btn-primary btn-block btn-flat submit-button"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.successfullCall()
                                    }}>
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            )
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(withRouter(ForgotPasswordRequest))


// WEBPACK FOOTER //
// ./src/modules/ForgotPassword/Components/ForgotPasswordRequest.js